import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { format } from 'date-fns';
import Decimal from 'decimal.js';
import colors from 'seagull/foundations/colors.module.scss';
import { useLocaleKeys } from '~/i18n';
import { SalesSummaryStatus } from '~/models';
import { utils } from '~/utils';
import CustomTooltip from '../charts/CustomTooltip/CustomTooltip';
export const salesWidgetTextsPath = 'pages.dashboard.salesWidget';
export const statusesOrder = [
    SalesSummaryStatus.Approved,
    SalesSummaryStatus.Reviewed,
    SalesSummaryStatus.Sent,
    SalesSummaryStatus.Expired,
    SalesSummaryStatus.Canceled,
    SalesSummaryStatus.Terminated
];
const getStatusToText = (texts)=>({
        [SalesSummaryStatus.Approved]: texts.statusLabels.signed(),
        [SalesSummaryStatus.Reviewed]: texts.statusLabels.reviewed(),
        [SalesSummaryStatus.Sent]: texts.statusLabels.notReviewed(),
        [SalesSummaryStatus.Canceled]: texts.statusLabels.withdrawn(),
        [SalesSummaryStatus.Terminated]: texts.statusLabels.terminated(),
        [SalesSummaryStatus.Expired]: texts.statusLabels.expired()
    });
export const statusToColor = {
    [SalesSummaryStatus.Approved]: colors.blue700,
    [SalesSummaryStatus.Reviewed]: colors.purple700,
    [SalesSummaryStatus.Sent]: colors.purple300,
    [SalesSummaryStatus.Canceled]: colors.dark200,
    [SalesSummaryStatus.Terminated]: colors.red500,
    [SalesSummaryStatus.Expired]: colors.purple50
};
export function RenderTooltip(_0) {
    let { testId } = _0, additionalProps = _object_without_properties(_0, [
        "testId"
    ]);
    const { t: salesWidgetTexts } = useLocaleKeys(salesWidgetTextsPath);
    const statusToText = getStatusToText(salesWidgetTexts);
    return /*#__PURE__*/ _jsx(CustomTooltip, _object_spread_props(_object_spread({}, additionalProps), {
        skin: "dark",
        testId: "".concat(testId, "-tooltip"),
        getTitle: (label, payload)=>{
            if (!payload || !payload.length) return '';
            const item = payload[0].payload;
            return format(item.date, 'MMMM');
        },
        getItems: (payload)=>{
            if (!payload || !payload.length) return;
            const item = payload[0].payload;
            return statusesOrder.filter((s)=>item.statuses[s].total.gt(0)).map((s)=>({
                    id: s,
                    label: "".concat(utils.formatNumberWithCommas(item.statuses[s].total), " ").concat(statusToText[s]),
                    color: statusToColor[s]
                }));
        },
        getBody: (payload)=>{
            if (!payload || !payload.length) return null;
            const item = payload[0].payload;
            const totalProposals = Object.values(item.statuses).reduce((acc, val)=>acc.add(val.total), new Decimal(0)).toNumber();
            return salesWidgetTexts.outOfProposalsSent({
                count: totalProposals,
                countText: totalProposals.toString()
            });
        }
    }));
}
export function getLegendItems(data, texts) {
    const statusToText = getStatusToText(texts);
    return statusesOrder.filter((status)=>data.some((item)=>item.statuses[status].total.gt(0))).map((status)=>({
            status,
            label: statusToText[status],
            color: statusToColor[status]
        }));
}
